import React, { useRef } from 'react';
import { useTheme } from '@mui/material/styles';
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid } from 'recharts';
import ExportButtons from '../Common/ExportButtons';

export interface TopItem {
  name: string;
  value: number;
  ref?: string; // bill or member reference
}

interface Props {
  data: TopItem[];
  height?: number;
  ariaLabel?: string;
}

const TopBarChart: React.FC<Props> = ({ data, height = 260, ariaLabel = 'Top items by activity' }) => {
  const theme = useTheme();
  const secondary = theme.palette.secondary.main;
  const grid = theme.palette.divider;
  const containerRef = useRef<HTMLDivElement | null>(null);

  return (
    <div ref={containerRef} role="img" aria-label={ariaLabel} style={{ width: '100%', height }}>
      <ExportButtons filename="top-items" data={data as any} containerRef={containerRef as any} />
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} margin={{ top: 8, right: 16, left: 0, bottom: 24 }}>
          <CartesianGrid stroke={grid} vertical={false} />
          <XAxis dataKey="name" angle={-20} textAnchor="end" height={50} stroke={theme.palette.text.secondary} />
          <YAxis stroke={theme.palette.text.secondary} allowDecimals={false} />
          <Tooltip
            contentStyle={{ background: theme.palette.background.paper, border: `1px solid ${grid}`, borderRadius: 8 }}
            formatter={(v: any, _n: any, p: any) => [v, p?.payload?.ref || 'Count']}
          />
          <Bar dataKey="value" fill={secondary} radius={[6, 6, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default TopBarChart;
